// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0647ff7b","990":"4bec1b3a"}[chunkId] + ".chunk.js";
};